/**
 * Repère le `<script>` tag qui a chargé le loader et extrait sa configuration
 * (public_key, URL de base du SDK).
 *
 * Stratégies pour retrouver le script tag, par ordre de préférence :
 *  1. `document.currentScript` (fiable mais indéfini dans les scripts async + dans certains contextes)
 *  2. fallback : recherche d'un `<script src="...loader.js" data-key="...">` dans le DOM
 */

export interface ScriptTagInfo {
  publicKey: string;
  sdkBaseUrl: string;
}

export function readScriptTag(): ScriptTagInfo | null {
  const tag = findScriptTag();
  if (tag === null) {
    return null;
  }

  const publicKey = tag.dataset.key;
  if (publicKey === undefined || publicKey === "") {
    return null;
  }

  const src = tag.src;
  if (typeof src !== "string" || src === "") {
    return null;
  }

  // sdkBaseUrl = URL du script sans le `/loader.js` final (et sans query).
  // Sert au core pour résoudre l'URL de ses propres chunks.
  const sdkBaseUrl = src.replace(/\/loader\.js(?:\?.*)?$/, "");

  return { publicKey, sdkBaseUrl };
}

function findScriptTag(): HTMLScriptElement | null {
  const current = document.currentScript;
  if (current instanceof HTMLScriptElement && current.dataset.key !== undefined) {
    return current;
  }

  const candidates = document.querySelectorAll<HTMLScriptElement>("script[data-key]");
  for (const candidate of candidates) {
    if (/\/loader\.js(?:\?|$)/.test(candidate.src)) {
      return candidate;
    }
  }

  return null;
}
